import React from 'react';
import styles from './UIGameVoteActions.module.scss';
import { T } from '@colonist/ui';
import { UIGameActionButton } from '../../../common/UIGameActionButton/index.ts';
import IconCheck from '@static/images/icon_check.svg';
import IconX from '@static/images/icon_x.svg';
export const UIGameVoteActions = ({ response, onAccept, onDecline })=>{
    const hasResponded = response != 'pending';
    const isDeclined = response == 'declined';
    const isAccepted = response == 'accepted';
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.actionsContainer
    }, /*#__PURE__*/ React.createElement(UIGameActionButton, {
        onClick: onDecline,
        className: styles.actionButton,
        iconPath: IconX,
        buttonType: "trade",
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:colonistCommon.buttons.decline"
        }),
        centerTextTooltip: true,
        highlight: isDeclined,
        disabled: hasResponded && !isDeclined
    }), /*#__PURE__*/ React.createElement(UIGameActionButton, {
        onClick: onAccept,
        className: styles.actionButton,
        iconPath: IconCheck,
        buttonType: "trade",
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:colonistCommon.buttons.accept"
        }),
        centerTextTooltip: true,
        highlight: isAccepted,
        disabled: hasResponded && !isAccepted
    }));
};
